import React from 'react';
import styled, { css } from 'styled-components';
import { BrokenLinkIcon } from 'assets/broken-link-icon';
import { DutchiePayButton, CenterItems, IconContainer } from 'src/payments/components';

type AccountChurnStepProps = {
  onCancel: () => void;
  onLinkBank: () => void;
};

export function AccountChurnStep({ onCancel, onLinkBank }: AccountChurnStepProps): JSX.Element {
  return (
    <Container data-testid='account-churn-step'>
      <CenterItems>
        <IconContainer>
          <BrokenLinkIcon />
        </IconContainer>
        <Title>Re-link unsuccessful</Title>
        <Body>
          Your Plaid link has expired. For security reasons Plaid requires that you create a fresh connection to your
          bank.
        </Body>
      </CenterItems>
      <ButtonRow>
        <CancelButton type='button' onClick={onCancel}>
          Cancel
        </CancelButton>
        <DutchiePayButton type='button' onClick={onLinkBank}>
          Link Bank
        </DutchiePayButton>
      </ButtonRow>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Title = styled.h2`
  ${({ theme: { colors } }) => css`
    color: ${colors.dutchiePayBlack};
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 12px;
    text-align: center;
  `}
`;

const Body = styled.p`
  ${({ theme: { colors } }) => css`
    color: ${colors.grey[35]};
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    margin-bottom: 0;
  `}
`;

const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;

  button {
    width: auto;
    min-width: 120px;
  }
`;

const CancelButton = styled.button`
  ${({ theme: { colors } }) => css`
    background: none;
    border: none;
    color: ${colors.grey[45]};
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    padding: 0;

    &:hover {
      color: ${colors.grey[30]};
    }
  `}
`;
